<template>
	<div>
		<!-- :backIntercept="true" @childBackEvent="back" -->
		<myheader :backFlag="true" :backIntercept="true" @childBackEvent="back" headTitle="发起文件签名"></myheader>
		<div class="header_extend_main" style="height: 100%;padding-bottom: 4.2rem;">
			<div class="header_extend_back"></div>
			<div class="header_extend_content_height vertical_flex">
				<div class="all_tips_content_card_padding8">
					<div class="text12 textcolormain font_weight_bold">选择发起方</div>
					<div class="display_flex margin_top_5">
						<span class="all_height_line16 display_inline_block text14 all_text_center font_weight_bold"
							style="width: 18%;">发起方</span>
						<span class="all_tips_input display_flex display_inline_block" style="width: 80%;"
							@click="selectStarters()">
							<div class="width_flex all_height_line16 text14 textcolor333 font_weight_900"
								style="overflow: hidden;">
								{{starter.corpName}}
							</div>
							<div class="selectstyle all_height_line16 text14 textcolor333 font_weight_900 display_flex"
								style="width: 1rem;"></div>
						</span>
					</div>
				</div>
				<div style="flex: 1;position: relative;border-radius: .3rem;" class="margin_top_8">
					<div style="overflow-y: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;">
						<div class="all_tips_content_card_padding8">
							<div class="all_tips_red text12 textcolor666">签署文件</div>
							<van-uploader accept="application/pdf" v-model="signFileList" class="margin_top_5"
								style="width: 100%;" :before-read="beforeReadPDF" :after-read="afterReadPDF"
								@delete="deleteFile">
								<template #default>
									<div class="all_text_center">
										<div v-if="signFileList.length==0"
											class="custom_btn display_flex text14 textcolor4d9efa"
											style="width: 50%;margin: 0 25%; align-items: center;justify-content: center;">
											+&nbsp;&nbsp;添加签署文件
										</div>
										<div v-else class="text14 textcolor4d9efa all_text_center">+&nbsp;&nbsp;继续添加
										</div>
										<div v-show="signFileList.length===0" class="display_flex text12 margin_top_5"
											style="padding: 0 1rem; align-items: center;justify-content: center;">
											<span class="textcolor4d9efa">支持pdf格式，</span>
											<span class="textcolorRed">大小不超过5M</span>
										</div>
									</div>
								</template>
							</van-uploader>
						</div>
						<div class="all_tips_content_card_padding8 margin_top_8">
							<div class="display_flex">
								<span class="display_flex display_inline_block" style="width: 80%;">
									<span
										class="all_tips_red text12 all_height_line16 textcolor666 display_inline_block"
										style="width: 50%;">签署方</span>
									<span v-show="orderChecked"
										class="text10 all_height_line16 textcolor4d9efa display_inline_block"
										style="width: 50%;text-align: right;padding-right: .8rem;">拖动即可排序</span>
								</span>
								<van-checkbox class="text12 textcolor333" shape="square"
									v-model="orderChecked">有序签</van-checkbox>
							</div>
							<draggable v-model="signerList" @start="onDragStart" @end="onDragEnd"
								:options="{ animation: 200,disabled: !orderChecked  }" draggable=".draggableItem">
								<div class="display_flex all_height24 draggableItem"
									style="margin: .5rem 2%;align-items: center;justify-content: center;"
									v-for="(item,index) in signerList" :key="item.id">
									<span v-if="orderChecked" class="text14 textcolormain display_flex" style="width: 1rem;height: 1rem;line-height: 1rem;
										border-radius: 50%;background-color: #eff6ff; border: .1rem solid #ddedfe;align-items: center;
										justify-content: center;margin-left: .5rem;">
										{{index}}
									</span>
									<img src="@/assets/images/signer.svg"
										style="width: 1rem;height: 1rem;margin-left: .5rem;" />
									<span style="margin-left: .5rem;flex: 1;">
										<div class="text12 textcolor333 font_weight_bold">{{ item.name }}</div>
										<div class="text12 textcolor666 margin_top_3">{{ item.phone }}</div>
									</span>
									<span style="width: 1rem;height: 1rem;margin-right: .5rem;">
										<van-icon name="cross" color="#666" @click="removeSigner(index)" />
									</span>
									<!-- <img src="@/assets/images/error.svg" style="width: 1rem;height: 1rem;" @click="removeSigner(index)" /> -->
								</div>
								<div slot="footer" role="group" aria-label="add" key="footer" style="width: 100%;">
									<div v-if="signerList.length==0"
										class="custom_btn display_flex text14 textcolor4d9efa"
										style="width: 50%;margin: 0 25%;align-items: center;justify-content: center;"
										@click="selectAddSigner()">
										+&nbsp;&nbsp;选择签署方
									</div>
									<div v-else class="text14 textcolor4d9efa all_text_center"
										@click="selectAddSigner()">+&nbsp;&nbsp;继续选择</div>
								</div>
							</draggable>
						</div>
						<div class="all_tips_content_card_padding8 margin_top_8">
							<div class="all_tips_red text12 textcolor666">签署事件主题</div>
							<div class="all_van_field" :class="{ isfocus: signFileNameFocus }">
								<van-field v-model="signFileName" type="text" placeholder="请输入签名文件名称" clearable
									@focus="getFocus(1)" @blur="onblur(1)">
								</van-field>

							</div>
							<div class="all_tips_red text12 textcolor666 margin_top_5">签署截止日期</div>
							<div class="all_van_field" :class="{ isfocus: expriyDateFocus }">
								<div class="display_inline_block" style="width: 70%;" @click="getExpiryDate()">
									<van-field v-model="expriyDateShow" type="text" placeholder="请选择签署截止日期" clearable
										readonly @focus="getFocus(2)" @blur="onblur(2)">
									</van-field>
								</div>
								<span class="display_inline_block all_line_height16" style="width: 28%;">
									<van-checkbox class="text12 textcolor333" shape="square" v-model="expriyDateChecked"
										@change="expriyDateNoLimit()">不限制</van-checkbox>
								</span>
								<!-- <span @click="setEnterpriseExpiryDate()"
									class="display_inline_block text14 all_text_right all_line_height20 textcolormain"
									style="width: 28%;"></span> -->
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="all_tips_bottom_card">
				<button class="all_button22 width_100 text16 bmain_active margin_top_5" @click="sumbit()">发起签署</button>
			</div>
		</div>
		<van-popup v-model:show="showAddSigner" round :overlay="true" :style="{ height: 'auto',width:'80%' }">
			<div class="addSignerPop">
				<div class="text14 font_weight_bold all_text_center textcolor333">添加签署方</div>
				<div class="all_tips_red text14 textcolor666 margin_top_5">姓名</div>
				<div class="all_van_field display_flex" style="align-items: center;justify-content: center;"
					:class="{ isfocus: signerNameFocus }">
					<van-field class="display_inline_block" style="width: 100%;" v-model="signerName" type="text"
						placeholder="请输入签署方姓名" clearable @focus="getFocus(3)" @blur="onblur(3)">
					</van-field>
					<button class="display_inline_block text12 all_height_line14 textcolorwhite backgroundC_main"
						style="width:25%;margin-left: 3%;border-radius: 5px;visibility: hidden;display: none;"
						@click="selectAddSigner()">选择</button>
				</div>
				<div class="all_tips_red text14 textcolor666 margin_top_5">手机号</div>
				<div class="all_van_field" :class="{ isfocus: signerPhoneFocus }">
					<van-field v-model="signerPhone" type="text" placeholder="请输入签署方手机号" clearable @focus="getFocus(4)"
						@blur="onblur(4)">
					</van-field>
				</div>
				<!-- <div class="text14 textcolor666 margin_top_5">备注</div>
				<div class="all_van_field" :class="{ isfocus: signerRemarkFocus }">
					<van-field v-model="signerRemark" type="text" placeholder="请输入签署方备注" clearable @focus="getFocus(5)"
						@blur="onblur(5)">
					</van-field>
				</div> -->
				<div class="all_height_line20 text14 margin_top_5 display_flex" style="padding: .2rem 0;">
					<button class="text14 all_line_height16 textcolormain backgroundC_#f2f2f2"
						style="display: inline-block;width:35%;margin-left: 10%;border-radius: 5px;"
						@click="popDimiss()">取消</button>
					<button class="text14 all_line_height16 textcolorwhite backgroundC_main"
						style="display: inline-block;width:35%;margin-left: 10%;border-radius: 5px;"
						@click="popSumbit()">确定</button>
				</div>
			</div>
		</van-popup>
		<van-popup v-model:show="showSearchSigner" round :overlay="true" closeable
			:style="{ height: '60%',width:'80%', }">
			<div class="addSignerPop" style="height: 100%;">
				<div class="text14 font_weight_bold all_text_center textcolor333">选择签署方</div>
				<van-search class="margin_top_5" v-model="searchSignerValue" clearable show-action
					placeholder="请输入搜索签名方姓名" @search="onReLoad">
					<template #action>
						<div @click="onReLoad">搜索</div>
					</template>
				</van-search>
				<div style="position: absolute;overflow: auto; top:5.1rem;bottom: 2.5rem; left: 0;right: 0;">
					<div style="position: relative;height: auto;">
						<van-list v-if="searchSignerList.length>0" v-model="listloading" :finished="listfinished"
							finished-text="没有更多了" @load="onLoad">
							<div v-for="(item,index) in searchSignerList" :key="index" style="padding: .2rem .8rem;"
								@click="onSelectedSigner(item)">
								<div v-if="index>0" class="horizontal_line"></div>
								<div class="display_flex all_height_line16"
									style="align-items: center;justify-content: center;">
									<span class="display_inline_block text12 textcolor666" style="width: 35%;">
										{{'姓名：'+item.actorName}}
									</span>
									<span class="display_inline_block text12 textcolor666" style="flex: 1;">
										{{'手机号：'+item.actorTag}}
									</span>
									<span class="display_inline_block display_flex"
										style="width: 1rem;height: 1rem;margin: .3rem;">
										<van-icon name="cross" color="#666"
											@click.stop="removeSearchSigner(item,index)" />
									</span>
								</div>
								<!-- <div class="display_flex all_height_line14"
									style="align-items: center;justify-content: center;">
									<span class="text12 textcolor666" style="flex: 1;">
										{{'备注：'+(item.actorMemo||'')}}
									</span>
									<span class="display_inline_block"
										style="width: 1rem;height: 1rem;margin-right: .5rem;">
										<van-icon name="cross" color="#666"
											@click.stop="removeSearchSigner(item,index)" />
									</span>
								</div> -->
							</div>
						</van-list>
						<van-empty v-else style="margin-top: 5vh;" description="没有数据" />
					</div>
				</div>
				<div class="custom_btn display_flex text14 textcolor4d9efa"
					style="width: 50%;align-items: center;justify-content: center;position: absolute;bottom: .5rem;left: 25%;"
					@click="showAddSignerPop()">
					+&nbsp;&nbsp;添加签署方
				</div>
			</div>
		</van-popup>
		<van-popup v-model:show="showSelectStarter" :overlay="true" position="bottom">
			<div class="selectStyleList">
				<div v-for="item in startersList">
					<div class="horizontal_line"></div>
					<div class="text all_height_line18 text14 textcolor666 backgroundC_white bwhite_ative all_text_center"
						@click="onSelectStarter(item)">{{item.corpName}}</div>
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="all_height_line24 text14 textcolor999 all_text_center" @click="showSelectStarter = false">
					取&nbsp;消
				</div>
			</div>
		</van-popup>
		<van-popup v-model="dateShow" position="bottom">
			<van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
				:formatter="dateFormatter" @confirm="dateConfirm" @cancel="dateCancel"></van-datetime-picker>
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Field,
		Checkbox,
		Uploader,
		DatetimePicker,
		Dialog,
		Icon,
		Search,
		Empty,
		List,
	} from 'vant';
	import {
		testCopyFile
	} from '../../utils/nativeTestDemo'
	import draggable from 'vuedraggable';
	export default {
		name: 'newquicksign',
		components: {
			draggable,
			[Uploader.name]: Uploader,
			[Checkbox.name]: Checkbox,
			[Field.name]: Field,
			[DatetimePicker.name]: DatetimePicker,
			[Icon.name]: Icon,
			[Search.name]: Search,
			[Empty.name]: Empty,
			[List.name]: List,
		},
		data() {
			return {
				type: '0',
				contractInfo: null,
				starter: '',
				showSelectStarter: false,
				startersList: [],
				signFileList: [],
				orderChecked: false,
				signerList: [],
				showAddSigner: false,
				signerName: '',
				signerPhone: '',
				signerRemark: '',
				signerNameFocus: false,
				signerPhoneFocus: false,
				signerRemarkFocus: false,
				signFileName: '',
				signFileNameFocus: false,
				expriyDateShow: '',
				expriyDate: '',
				expriyDateFocus: false,
				//expriyDateHint:'请选择签署截止日期',
				expriyDateChecked: false,
				componentData: {
					props: {
						type: "transition",
						name: "flip-list"
					}
				},
				dateShow: false,
				minDate: new Date(),
				maxDate: new Date(2100, 11, 31),
				currentDate: new Date(),
				showSearchSigner: false,
				searchSignerValue: '',
				//每页数量
				pageSize: 3,
				//第几页
				pageNum: 1,
				//
				searchSignerList: [],
				//
				listloading: false,
				//
				listfinished: false,
				//
				isAddShareFiles: false,
			}
		},
		methods: {
			//
			back() {
				if (this.isAddShareFiles) {
					this.$router.replace({
						path: '/quicksignlist',
					})
				} else {
					this.$router.back()
				}
			},
			//
			onReLoad() {
				this.pageNum = 1
				this.searchSignerList = []
				this.listfinished = false;
				this.listloading = true;
				this.onSearchSigner()
			},
			//
			onLoad() {
				this.pageNum++
				this.onSearchSigner()
			},
			//
			onSelectedSigner(item) {
				// this.signerName = item.actorName
				// this.signerPhone = item.actorTag
				// this.signerRemark = item.actorMemo
				this.signerList.push({
					name: item.actorName,
					phone: item.actorTag,
					corpName: item.actorMemo
				})
				this.showSearchSigner = false
				//this.showAddSigner = false
			},
			//
			selectAddSigner() {
				// if (this.signerName) {
				// 	this.searchSignerValue = this.signerName
				// 	this.onReLoad()
				// } else {
				// 	this.searchSignerValue = ''
				// 	this.searchSignerList = []
				// }
				this.searchSignerValue = ''
				this.searchSignerList = []
				this.showSearchSigner = true
			},
			//
			removeSearchSigner(item) {
				let that = this
				Dialog.confirm({
						title: '提示',
						message: '确定删除当前签署方记录？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						that.onRemoveSigner(item)
					}).catch((err) => {
						//取消
					});
			},
			//
			onRemoveSigner(item, index) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/quick/api/removeBook', {
					id: item.id
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast("删除成功！");
						this.searchSignerList.split(index, 1)
					} else {
						this.$Toast(res.message || res.messageDetail || "删除失败，请重试！");
					}
				}).catch((err) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast("删除失败，请重试！");
					console.log('/quick/api/removeBook', err)
				})
			},
			//
			onSearchSigner() {
				if (!this.searchSignerValue) {
					this.$Toast('请输入搜索关键词！')
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				//this.listloading = true;
				this.$post('/quick/api/queryBooks', {
					actorName: this.searchSignerValue,
					pageParams: {
						desc: true,
						orderBy: "created_time",
						current: this.pageNum,
						size: this.pageSize,
					}
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.listloading = false;
					if (res.success && res.data) {
						//console.log(typeof this.searchSignerList)
						this.searchSignerList = this.searchSignerList.concat(res.data.records)
						// 加载状态结束
						//数据全部加载完成
						if (this.searchSignerList.length >= res.data.total) {
							this.listfinished = true;
						}
					} else {
						this.$Toast(res.message || res.messageDetail || "搜索失败，请重试！");
					}
				}).catch((err) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast("搜索失败，请重试！");
					console.log('/quick/api/queryBooks', err)
				})
			},
			//
			sumbit() {
				if (!this.starter) {
					this.$Toast('请选择发起方！')
					return
				}
				let fileList = this.signFileList.filter((item) => {
					return item.info
				})
				if (fileList.length == 0) {
					this.$Toast('请添加签署文件！')
					return
				}
				if (this.signerList.length == 0) {
					this.$Toast('请添加签署方！')
					return
				}
				if (!this.signFileName) {
					this.$Toast('请补全签署事件主题！')
					return
				}
				if (!this.expriyDateChecked && !this.expriyDate) {
					//this.expriyDateChecked
					this.$Toast('请补全签署截止日期！')
					return
				}
				let signfiles = []
				fileList.forEach((item, index) => {
					item.info.displayNo = index
					signfiles.push(item.info)
				})
				let signerss = []
				this.signerList.forEach((item, index) => {
					signerss.push({
						displayName: index,
						signerMemo: item.corpName,
						signerName: item.name,
						signerTag: item.phone
					})
				})
				const data = {
					contractId: this.contractInfo.contractId,
					contractName: this.signFileName,
					corpId: this.starter.corpId,
					corpName: this.starter.corpName,
					expireDate: !this.expriyDateChecked ? this.expriyDate : '',
					files: signfiles,
					signByLine: this.orderChecked,
					signers: signerss
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/quick/api/submit', data).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast("发起签署成功！");
						this.back()
						//this.$router.back()
					} else {
						this.$Toast(res.message || res.messageDetail || "发起签署失败，请重试！");
					}
				}).catch((err) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast("发起签署失败，请重试！");
					console.log('/quick/api/submit', err)
				})
			},
			//
			selectStarters() {
				this.showSelectStarter = true
			},
			//
			showAddSignerPop() {
				// this.searchSignerValue = ''
				// this.searchSignerList = []
				// this.showSearchSigner = true
				this.signerName = ''
				this.signerPhone = ''
				this.signerRemark = ''
				this.showAddSigner = true
			},
			//
			onSelectStarter(item) {
				this.starter = item
				this.showSelectStarter = false
			},
			//
			popDimiss() {
				this.showAddSigner = false
			},
			//
			popSumbit() {
				if (!this.signerName) {
					this.$Toast('请补全签署方姓名！')
					return
				}
				if (!this.signerPhone) {
					this.$Toast('请补全签署方账户或手机号！')
					return
				}
				this.signerList.push({
					name: this.signerName,
					phone: this.signerPhone,
					corpName: this.signerRemark
				})
				this.showAddSigner = false
				this.showSearchSigner = false
			},
			//
			removeSigner(index) {
				let that = this
				Dialog.confirm({
						title: '提示',
						message: '确定删除当前签署方？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						that.signerList.splice(index, 1)
					}).catch((err) => {
						//取消
					});
			},
			onDragStart() {

			},
			onDragEnd() {

			},
			//获取焦点
			getFocus(id) {
				switch (id) {
					case 1:
						this.signFileNameFocus = true
						this.expriyDateFocus = false
						break;
					case 2:
						this.expriyDateFocus = true
						break;
					case 3:
						this.signerNameFocus = true
						break;
					case 4:
						this.signerPhoneFocus = true
						break;
					case 5:
						this.signerRemarkFocus = true
						break;
				}
			},
			//
			onblur(id) {
				switch (id) {
					case 1:
						this.signFileNameFocus = false
						break;
					case 2:
						this.expriyDateFocus = false
						break;
					case 3:
						this.signerNameFocus = false
						break;
					case 4:
						this.signerPhoneFocus = false
						break;
					case 5:
						this.signerRemarkFocus = false
						break;
				}
			},
			//文件长传前 pdf
			beforeReadPDF(file) {
				//console.log(file)
				if (file.type != 'application/pdf') {
					this.$Toast('请上传pdf文件');
					return false;
				}
				const size = file.size / 1024 / 1024;
				if (size > 5) {
					this.$Toast('请上传小于5MB大小的pdf文件');
					return false;
				}
				// if(file.name.length>24){
				// 	let name = file.name
				// 	file.name = name.slice(0, 20)+'.pdf'
				// }
				return true;
			},
			//文件长传后
			afterReadPDF(file) {
				//console.log(file)
				//console.log(this.signFileList)
				this.uploadFile('pdf', file)
			},
			//
			deleteFile(file) {
				console.log(file)
				if (this.signFileList.length > 0) {
					this.signFileName = this.signFileList[0].file.name.replace('.pdf', '')
				} else {
					this.signFileName = ''
				}
			},
			//上传pdf文件
			uploadFile(flag, file) {
				if (flag === 'upload_pdf') {
					this.signFileList.push(file)
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/quick/api/upload', {
						file: file.file
					}, 'form')
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							file.status = 'success';
							file.message = '上传成功';
							file.info = res.data
							console.log(this.signFileList)
							// this.signFileList.forEach(item=>{
							// 	console.log(file === item)
							// 	console.log(file.file === item.file)
							// })
							if (this.signFileList.length > 0) {
								this.signFileName = this.signFileList[0].file.name.replace('.pdf', '')
							} else {
								this.signFileName = ''
							}
						} else {
							file.status = 'failed';
							file.message = '上传失败';
							console.log(this.signFileList)
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						this.$Toast("上传文件失败，请重试！");
						file.status = 'failed';
						file.message = '上传失败';
						console.log('/quick/api/upload', err)
					})
			},
			//
			getEditQuick(contractid) {
				this.$get("/quick/api/getEditQuick", {
					contractId: contractid
				}).then((res) => {
					if (res.success && res.data) {
						this.contractInfo = res.data
						this.starter = {
							corpId: this.contractInfo.corpId,
							corpName: this.contractInfo.corpName
						}
						this.signFileName = this.contractInfo.contractName
						if (this.contractInfo.expireDate) {
							this.expriyDateShow = this.contractInfo.expireDate.split('T')[0]
							this.expriyDate = this.contractInfo.expireDate
							this.expriyDateChecked = false
						} else {
							this.expriyDateShow = '不限制'
							this.expriyDateChecked = true
						}
						this.contractInfo.signers.forEach(item => {
							this.signerList.push({
								name: item.signerName,
								phone: item.signerTag,
								corpName: item.signerMemo
							})
						})
						this.contractInfo.files.forEach(item => {
							this.signFileList.push({
								content: '2113',
								file: {
									name: item.fileName
								},
								info: item,
							})
						})
						this.orderChecked = this.contractInfo.signByLine
					} else {
						this.$Toast((res.message || res.messageDetail || "获取合同信息失败") + '，请重试！');
						this.$router.back()
					}
				});
			},
			//
			getNewQuick() {
				this.$get("/quick/api/getNewQuick").then((res) => {
					if (res.success && res.data) {
						this.contractInfo = res.data
					} else {
						this.$Toast(res.message || res.messageDetail || "获取合同id失败，请重试！");
						this.$router.back()
					}
				});
			},
			//获取发起方列表数据
			getStarterList() {
				this.$get("/quick/api/getStarters").then((res) => {
					if (res.success && res.data) {
						this.startersList = res.data
						if (this.startersList && Array.isArray(this.startersList) && this.startersList.length >
							0) {
							this.starter = this.startersList[0]
						}
					} else {
						this.$Toast(res.message || res.messageDetail || "没有获取到发起方列表，请退出页面重试！");
					}
				});
			},
			//
			expriyDateNoLimit() {
				if (this.expriyDateChecked) {
					this.expriyDate = ''
					this.expriyDateShow = '不限制'
				} else {
					this.expriyDateShow = ''
				}
			},
			//
			getExpiryDate() {
				const date = this.expriyDateShow.split('-')
				if (date && Array.isArray(date) && date.length == 3) {
					this.currentDate = new Date(date[0], date[1] - 1, date[2])
				}
				if (!this.expriyDateChecked) {
					this.dateShow = true
				}
			},
			dateFormatter(type, val) {
				return val
			},
			//日期确定
			dateConfirm() {
				//console.log(this.currentDate)
				this.expriyDate = this.Tool.getDataISOString(this.currentDate.toISOString())
				this.expriyDateShow = this.Tool.formate(this.currentDate, "yyyy-MM-dd")
				this.dateShow = false
			},
			//日期取消
			dateCancel() {
				this.dateShow = false
			},
			getJsFile(plusFilePath) {
				let that = this
				return new Promise((resolve, reject) => {
					window.plus.io.resolveLocalFileSystemURL(
						plusFilePath,
						function(entry) {
							entry.file(function(file) {
								//console.log('file内容:', file);
								const reader = new window.plus.io.FileReader();
								reader.onloadend = function(e) {
									console.log('reader内容:', e);
									const base64WithoutPrefix = e.target.result.split(
										';base64,').pop();
									const binaryData = atob(base64WithoutPrefix);
									const arrayBuffer = new ArrayBuffer(binaryData.length);
									const uint8Array = new Uint8Array(arrayBuffer);
									for (let i = 0; i < binaryData.length; i++) {
										uint8Array[i] = binaryData.charCodeAt(i);
									}
									const blob = new Blob([uint8Array], {
										type: 'application/pdf'
									});
									resolve({
										content: e.target.result,
										file: new File([blob], file.name, {
											type: 'application/pdf'
										})
									});
								};
								reader.readAsDataURL(file);
							});
						},
						function(e) {
							reject(new Error('文件获取失败: ' + e.message));
							//that.$Toast('文件获取失败: ' + JSON.parse(e));
						}
					);
				});
			},
			//初始化
			init() {
				let that = this
				//console.log('init', this.$route.query)
				this.type = this.$route.query.type
				const files = this.$store.state.newquicksignfiles
				//console.log('--newquicksign-init', files)
				if (files) {
					this.isAddShareFiles = true
					this.signFileList = []
					const fileArrs = files.split(',')
					//console.log('--newquicksign-init', fileArrs)
					fileArrs.forEach(item => {
						//var filePath = plus.io.convertAbsoluteFileSystem(fileArrs[0])
						const filePath = 'file://' + item
						//console.log('init', filePath)
						const urlPath = decodeURIComponent(filePath)
						const url = window.plus.io.convertAbsoluteFileSystem(urlPath)
						//console.log('init', urlPath)
						this.getJsFile(url).then(file => {
							console.log('--newquicksign-getJsFile', file)
							this.uploadFile('upload_pdf', file)
						}).catch(err => {
							console.log('getJsFile', err)
							this.signFileList.push({
								content: '2113',
								file: {
									name: this.getFileName(item)
								},
								status: 'failed',
								message: '上传失败'
							})
						})
					})
				}
				this.$store.dispatch(this.$addQuickSignFiles, '')
				const harmonyFiles = this.$store.state.harmonysharefiles
				if (harmonyFiles) {
					this.isAddShareFiles = true
					this.signFileList = []
					harmonyFiles.record.forEach(item => {
						//console.log('harmonyFiles-item-=', item)
						if(item.size<5000000){
							const binaryData = atob(item.base64str);
							const arrayBuffer = new ArrayBuffer(binaryData.length);
							const uint8Array = new Uint8Array(arrayBuffer);
							for (let i = 0; i < binaryData.length; i++) {
								uint8Array[i] = binaryData.charCodeAt(i);
							}
							const blob = new Blob([uint8Array], {
								type: 'application/pdf'
							});
							this.uploadFile('upload_pdf', {
								content: item.base64str,
								file: new File([blob], item.name, {
									type: 'application/pdf'
								})
							})
						}
					})
				}
				this.$store.dispatch('actionHarmonyShareFiles', '')
				if (this.type === '0') {
					this.getNewQuick()
				} else {
					const contractId = this.$route.query.contractId
					this.getEditQuick(contractId)
				}
				this.getStarterList()
			},
			//
			getFileName(filePath) {
				const index = filePath.lastIndexOf('/')
				const filename = filePath.substring(index + 1);
				return filename
			},
			//
			safeDecode(encodedStr) {
				try {
					return decodeURIComponent(encodedStr);
				} catch (error) {
					console.error("解码失败:", error);
					// 尝试移除无效编码后重试
					const sanitized = encodedStr.replace(/%[^0-9A-Fa-f][^0-9A-Fa-f]?/g, "");
					return decodeURIComponent(sanitized) || encodedStr;
				}
			},
		},
		computed: {
			// 将store中的值映射为计算属性
			myValue() {
				return this.$store.state.newquicksignfiles;
			}
		},
		watch: {
			// 监听计算属性的变化
			myValue(newVal, oldVal) {
				//console.log('--newquicksign-watch-=', oldVal, '→', newVal);
				// 执行你的业务逻辑
				if (newVal) {
					this.signFileList = []
					this.isAddShareFiles = true
					const fileArrs = newVal.split(',')
					//console.log('init', fileArrs)
					fileArrs.forEach(item => {
						//var filePath = plus.io.convertAbsoluteFileSystem(fileArrs[0])
						const filePath = 'file://' + item
						//console.log('init', filePath)
						const urlPath = decodeURIComponent(filePath)
						const url = window.plus.io.convertAbsoluteFileSystem(urlPath)
						this.getJsFile(url).then(file => {
							console.log('getJsFile', file)
							this.uploadFile('upload_pdf', file)
						}).catch(err => {
							console.log('getJsFile', err)
							this.signFileList.push({
								content: '2113',
								file: {
									name: this.getFileName(item)
								},
								status: 'failed',
								message: '上传失败'
							})
							//this.$Toast('getJsFile' + JSON.parse(err));
						})
					})
				}
				this.$store.dispatch(this.$addQuickSignFiles, '')
			}
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.addSignerPop {
		padding: 5% .8rem;
	}

	.draggableItem {
		background-color: #f2f2f2;
		border-radius: .1rem;
	}

	.flip-list-move {
		transition: transform 0.5s;
	}

	.custom_btn {
		background-color: #eff6ff;
		border: .05rem solid #ddedfe;
		border-radius: .2rem;
		height: 1.6rem;
		line-height: 1.6rem;
		text-align: center;
	}

	// ::v-deep .van-uploader__mask{
	// 	max-width: 100vw;
	// 	overflow: hidden;
	// }

	/* 修改上传按钮背景和圆角 */
	::v-deep .van-uploader__upload {
		background-color: #ff5500;
		border-radius: 10px;
	}

	::v-deep .van-uploader__upload:active {
		transform: scale(0.95);
		transition: transform 0.2s;
	}

	::v-deep .van-uploader__wrapper {
		display: flex;
		flex-direction: column;
		/* 上传按钮在右侧 */
	}

	::v-deep .van-uploader__preview {
		//margin-right: 15px;
		/* 预览项间距 */
	}

	::v-deep .van-uploader__file {
		width: 100%;
		height: 2rem;
		padding-left: .8rem;
		flex-direction: row;
	}

	::v-deep .van-uploader__file-name {
		font-weight: bold;
		font-size: .6rem;
		line-height: 2rem;
	}
</style>